import React from 'react';
import { ActionContext, MenuContext, MenuRouteContext } from './AppContext';
import { Switch } from 'react-router-dom';
import useAuthorizedApp from './AppHook';
import { RouteConfig, renderRoutes } from 'react-router-config';

interface AppGuardProps {
  routes: RouteConfig[];
}

const AppGuard = ({ routes }: AppGuardProps) => {
  const {
    authorizedMenus,
    authorizedAction,
    authorizedMenuMapper,
  } = useAuthorizedApp();

  return (
    <MenuContext.Provider value={authorizedMenus}>
      <MenuRouteContext.Provider value={authorizedMenuMapper}>
        <ActionContext.Provider value={authorizedAction}>
          <Switch>{renderRoutes(routes)}</Switch>
        </ActionContext.Provider>
      </MenuRouteContext.Provider>
    </MenuContext.Provider>
  );
};

export default AppGuard;
